import { render, staticRenderFns } from "./material.vue?vue&type=template&id=7e7c39b6&scoped=true&"
import script from "./material.vue?vue&type=script&lang=js&"
export * from "./material.vue?vue&type=script&lang=js&"
import style0 from "./material.vue?vue&type=style&index=0&id=7e7c39b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7c39b6",
  null
  
)

export default component.exports